"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var stimulus_1 = require("stimulus");
var browser_1 = require("@sentry/browser");
var dialog_store_1 = __importDefault(require("~/stores/dialog_store"));
var ADDABLE_STORE_SIZE_PATH = '/api/users/estimates/entries/addable_store_size';
var ReentryFormController = /** @class */ (function (_super) {
    __extends(ReentryFormController, _super);
    function ReentryFormController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.connect = function () {
            var _a;
            (_a = _this.purchaseMethodInputTargets) === null || _a === void 0 ? void 0 : _a.forEach(function (elt) {
                elt.addEventListener('change', _this.updateAddableStoreSize);
            });
        };
        _this.updateAddableStoreSize = function () {
            var _a;
            var original_id = (_a = _this.originalIdTarget) === null || _a === void 0 ? void 0 : _a.value;
            var purchase_methods = _this.purchaseMethodInputTargets ? _this.purchaseMethodInputTargets.filter(function (elt) { return elt.checked; }).map(function (elt) { return elt.value; }) : [];
            var addableStoreSizeBox = document.querySelector('.usersEstimatesEntries-ReentryForm_AddableStoreSizeBox');
            var addableStoreSizeBoxHidden = document.querySelector('.usersEstimatesEntries-ReentryForm_AddableStoreSizeBox-hidden');
            var nonStoreSizeBox = document.querySelector('.usersEstimatesEntries-ReentryForm_NonStoreSizeBox');
            var nonStoreSizeBoxHidden = document.querySelector('.usersEstimatesEntries-ReentryForm_NonStoreSizeBox-hidden');
            if (purchase_methods.length === 0 && addableStoreSizeBox && nonStoreSizeBoxHidden) {
                addableStoreSizeBox.classList.replace('usersEstimatesEntries-ReentryForm_AddableStoreSizeBox', 'usersEstimatesEntries-ReentryForm_AddableStoreSizeBox-hidden');
                nonStoreSizeBoxHidden.classList.replace('usersEstimatesEntries-ReentryForm_NonStoreSizeBox-hidden', 'usersEstimatesEntries-ReentryForm_NonStoreSizeBox');
                return;
            }
            var params = {
                original_id: original_id,
                purchase_methods: purchase_methods
            };
            axios_1.default.get(ADDABLE_STORE_SIZE_PATH, { params: params })
                .then(function (response) {
                var addableStoreSize = response.data.size;
                if (addableStoreSize === 0 && addableStoreSizeBox && nonStoreSizeBoxHidden) {
                    addableStoreSizeBox.classList.replace('usersEstimatesEntries-ReentryForm_AddableStoreSizeBox', 'usersEstimatesEntries-ReentryForm_AddableStoreSizeBox-hidden');
                    nonStoreSizeBoxHidden.classList.replace('usersEstimatesEntries-ReentryForm_NonStoreSizeBox-hidden', 'usersEstimatesEntries-ReentryForm_NonStoreSizeBox');
                }
                else if (addableStoreSizeBoxHidden && nonStoreSizeBox) {
                    addableStoreSizeBoxHidden.classList.replace('usersEstimatesEntries-ReentryForm_AddableStoreSizeBox-hidden', 'usersEstimatesEntries-ReentryForm_AddableStoreSizeBox');
                    nonStoreSizeBox.classList.replace('usersEstimatesEntries-ReentryForm_NonStoreSizeBox', 'usersEstimatesEntries-ReentryForm_NonStoreSizeBox-hidden');
                }
                if (_this.sizeTextTarget) {
                    _this.sizeTextTarget.textContent = addableStoreSize;
                }
            })
                .catch(function (error) {
                if (error.response && error.response.data && error.response.data.error) {
                    dialog_store_1.default.showDialogWithCloseButton('査定可能業者数の取得に失敗しました');
                }
                else {
                    (0, browser_1.captureException)(error);
                }
            });
        };
        return _this;
    }
    ReentryFormController.targets = ['originalId', 'sizeText', 'purchaseMethodInput'];
    return ReentryFormController;
}(stimulus_1.Controller));
exports.default = ReentryFormController;
